import React, { Fragment, useContext, useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Button } from "primereact/button";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import ButtonMui from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import Menu from "../Menu";
import { MultiSelect } from "primereact/multiselect";
import { saveAs } from "file-saver";
import clienteAxios from "../../../config/axios";

const FILAS = [
  { clave: "cheques", nombre: "CHEQ. ACRED/DEB HOY" },
  { clave: "efectivo", nombre: "EFECTIVO" },
  { clave: "transferencias", nombre: "BANCOS" },
];

const formatoImporte = (valor) =>
  "$ " +
  Number(valor).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const hoyISO = () => {
  const d = new Date();
  return (
    d.getFullYear() +
    "-" +
    String(d.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(d.getDate()).padStart(2, "0")
  );
};

const formatoFecha = (valor) => {
  const [anio, mes, dia] = valor.split("-");
  return `${dia}/${mes}/${anio}`;
};

export default function ListadoResumenDiario(props) {
  const [fecha, setFecha] = useState(hoyISO());
  const [selectedCities, setSelectedCities] = useState([]);
  const [bandInicio, setBandInicio] = useState(false);
  const [resumen, setResumen] = useState(null);
  const [cargando, setCargando] = useState(false);

  const toast = useRef(null);

  let navigate = useNavigate();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, empresaElegida, empresas, obtenerAcceso, obtenerEmpresas } =
    configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "ResumenDiarioTesoreria",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerEmpresas();
  }, []);

  const exitClick = () => {
    navigate("/");
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Resumen Diario",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  // Arma las filas del cuadro con la fila de total
  const armarFilas = (datos) => {
    const filas = FILAS.map((fila) => ({
      concepto: fila.nombre,
      saldoInicial: datos[fila.clave].saldoInicial,
      ingreso: datos[fila.clave].ingreso,
      egreso: datos[fila.clave].egreso,
      saldoFinal: datos[fila.clave].saldoFinal,
    }));
    // Los saldos del total solo se suman cuando todas las filas los tienen
    const conSaldos = filas.every((item) => item.saldoInicial !== null);
    filas.push({
      concepto: "TOTAL",
      saldoInicial: conSaldos
        ? filas.reduce((acc, item) => acc + item.saldoInicial, 0)
        : null,
      ingreso: filas.reduce((acc, item) => acc + item.ingreso, 0),
      egreso: filas.reduce((acc, item) => acc + item.egreso, 0),
      saldoFinal: conSaldos
        ? filas.reduce((acc, item) => acc + item.saldoFinal, 0)
        : null,
    });
    return filas;
  };

  const formatoSaldo = (valor) =>
    valor === null || valor === undefined ? "-" : formatoImporte(valor);

  const numeroExcel = (valor) =>
    valor === null || valor === undefined ? "" : Number(valor.toFixed(2));

  const consultar = async () => {
    if (!fecha) {
      mensajeAlerta("Resumen Diario", "Debe indicar la fecha !.", "error");
      return null;
    }
    if (!selectedCities || selectedCities.length === 0) {
      mensajeAlerta(
        "Resumen Diario",
        "Debe indicar al menos una empresa !.",
        "error"
      );
      return null;
    }
    setCargando(true);
    try {
      const respuesta = await clienteAxios.post(
        "/api/configuracion/obtenerresumendiariotesoreria",
        { fecha, selectedCities }
      );
      const filas = armarFilas(respuesta.data);
      setResumen(filas);
      setCargando(false);
      return filas;
    } catch (error) {
      console.log(error);
      mensajeAlerta(
        "Resumen Diario",
        "Hubo un error al obtener la información !.",
        "error"
      );
      setCargando(false);
      return null;
    }
  };

  const textoEmpresas = () =>
    selectedCities.map((item) => item.nombre).join(" - ");

  const exportExcel = async () => {
    const filas = await consultar();
    if (!filas) return;
    const hoja = filas.map((fila) => ({
      Concepto: fila.concepto,
      "Saldo Inicial": numeroExcel(fila.saldoInicial),
      Ingreso: Number(fila.ingreso.toFixed(2)),
      Egreso: Number(fila.egreso.toFixed(2)),
      "Saldo Final": numeroExcel(fila.saldoFinal),
    }));
    import("xlsx").then((xlsx) => {
      const workbook = {
        Sheets: { resumen: xlsx.utils.json_to_sheet(hoja) },
        SheetNames: ["resumen"],
      };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(blob, "resumenDiario_" + fecha + ".xlsx");
    });
  };

  const exportPdf = async () => {
    const filas = await consultar();
    if (!filas) return;
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default("p");
        doc.setFontSize(12);
        doc.text(`Resumen Diario de Tesorería - ${formatoFecha(fecha)}`, 10, 10);
        doc.setFontSize(8);
        // Partir el texto de empresas en varias líneas si no entra en el ancho
        const lineasEmpresas = doc.splitTextToSize(
          `Empresas: ${textoEmpresas()}`,
          doc.internal.pageSize.getWidth() - 20
        );
        doc.text(lineasEmpresas, 10, 16);
        const inicioTabla = 16 + lineasEmpresas.length * 4 + 2;

        doc.autoTable(
          [
            { title: "", dataKey: "concepto" },
            { title: "SALDO INICIAL", dataKey: "saldoInicial" },
            { title: "INGRESO", dataKey: "ingreso" },
            { title: "EGRESO", dataKey: "egreso" },
            { title: "SALDO FINAL", dataKey: "saldoFinal" },
          ],
          filas.map((fila) => ({
            concepto: fila.concepto,
            saldoInicial: formatoSaldo(fila.saldoInicial),
            ingreso: formatoImporte(fila.ingreso),
            egreso: formatoImporte(fila.egreso),
            saldoFinal: formatoSaldo(fila.saldoFinal),
          })),
          {
            startY: inicioTabla,
            margin: { left: 10, right: 10 },
            theme: "grid",
            styles: { fontSize: 9 },
            headStyles: { halign: "center" },
            columnStyles: {
              0: { fontStyle: "bold", cellWidth: 50 },
              1: { halign: "right" },
              2: { halign: "right" },
              3: { halign: "right" },
              4: { halign: "right" },
            },
            didParseCell: (data) => {
              if (
                data.cell.section === "body" &&
                data.row.index === filas.length - 1
              ) {
                data.cell.styles.fontStyle = "bold";
              }
            },
          }
        );
        window.open(doc.output("bloburl"));
      });
    });
  };

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Resumen Diario de Tesorería"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <Button
          icon="pi pi-search"
          onClick={consultar}
          className="p-button-raised"
          label="Ver"
          loading={cargando}
        />
        <Button
          icon="pi pi-file-excel"
          onClick={exportExcel}
          className="p-button-raised p-button-success"
          label="Excel"
        />
        <Button
          icon="pi pi-file-pdf"
          onClick={exportPdf}
          className="p-button-raised p-button-warning"
          style={{ marginRight: "1em" }}
          label="PDF"
        />
        <ButtonMui
          onClick={exitClick}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
        >
          Salir
        </ButtonMui>
      </div>
    );
  };

  // INICIO

  if (!bandInicio && empresas && empresas.length > 0 && empresaElegida) {
    setBandInicio(true);
    const index = empresas.findIndex((item) => item.id === empresaElegida.id);
    if (index !== -1) {
      setSelectedCities([empresas[index]]);
    }
  }

  // FIN

  const celda = {
    border: "1px solid #333",
    padding: "0.5em 1em",
  };

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Dialog
          header={renderHeader()}
          visible={true}
          closable={false}
          footer={renderFooter()}
          breakpoints={{ "960px": "90vw" }}
          style={{ width: "75vw", paddingBottom: "0" }}
          position="top"
        >
          <Grid container spacing={3} style={{ marginTop: "1vw" }}>
            <Grid item xs={12} md={3}>
              <TextField
                id="fecha"
                label="Fecha"
                type="date"
                variant="standard"
                fullWidth
                value={fecha}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  setFecha(e.target.value);
                  setResumen(null);
                }}
              />
            </Grid>

            <Grid item xs={12} md={9} style={{ paddingLeft: "1vw" }}>
              <label htmlFor="id">Empresas</label>
              <MultiSelect
                value={selectedCities}
                onChange={(e) => {
                  setSelectedCities(e.value);
                  setResumen(null);
                }}
                options={
                  empresas ? empresas.filter((item) => item.habilitado) : null
                }
                optionLabel="nombre"
                placeholder="Seleccione las empresas"
                maxSelectedLabels={10}
                display="chip"
                style={{ marginLeft: "1vw" }}
              />
            </Grid>

            {resumen ? (
              <Grid item xs={12} style={{ overflowX: "auto" }}>
                <table
                  style={{
                    borderCollapse: "collapse",
                    marginTop: "1vw",
                    minWidth: "28rem",
                  }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: "0.5em 1em" }}></th>
                      <th style={celda}>SALDO INICIAL</th>
                      <th style={celda}>INGRESO</th>
                      <th style={celda}>EGRESO</th>
                      <th style={celda}>SALDO FINAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumen.map((fila) => {
                      const esTotal = fila.concepto === "TOTAL";
                      return (
                        <tr
                          key={fila.concepto}
                          style={{ fontWeight: esTotal ? "bold" : "normal" }}
                        >
                          <td
                            style={
                              esTotal
                                ? { padding: "0.5em 1em" }
                                : { ...celda, fontWeight: "bold" }
                            }
                          >
                            {esTotal ? "" : fila.concepto}
                          </td>
                          <td style={{ ...celda, textAlign: "right" }}>
                            {formatoSaldo(fila.saldoInicial)}
                          </td>
                          <td style={{ ...celda, textAlign: "right" }}>
                            {formatoImporte(fila.ingreso)}
                          </td>
                          <td style={{ ...celda, textAlign: "right" }}>
                            {formatoImporte(fila.egreso)}
                          </td>
                          <td style={{ ...celda, textAlign: "right" }}>
                            {formatoSaldo(fila.saldoFinal)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Grid>
            ) : null}
          </Grid>
        </Dialog>
      ) : null}
    </Fragment>
  );
}
